export const languageFormatter = (language) => {
  switch (language) {
    case "english":
      return "Inglés";
    case "spanish":
      return "Español";
    default:
      return "Español";
  }
};
export const typeFormatter = (type) => {
  switch (type) {
    case "national":
      return "Nacional";
    case "international":
      return "Internacional";
    default:
      return "Nacional";
  }
};
